const formatMoney = (stringPrice) =>
  new Intl.NumberFormat('es-CL', { currency: 'CLP' })
    .format(stringPrice)
    .toString()
export default formatMoney
